import React, { useCallback, useEffect, useState, Component } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CompactNavigation } from '../components/CompactNavigation';
import { HeroSlide } from '../components/slides/HeroSlide';
import { ProblemSlide } from '../components/slides/ProblemSlide';
import { SolutionSlide } from '../components/slides/SolutionSlide';
import { HardwareSlide } from '../components/slides/HardwareSlide';
import { SoftwareSlide } from '../components/slides/SoftwareSlide';
import { PortalSlide } from '../components/slides/PortalSlide';
import { ShowcaseSlide } from '../components/slides/ShowcaseSlide';
import { IntegrationSlide } from '../components/slides/IntegrationSlide';
import { CTASlide } from '../components/slides/CTASlide';
const SLIDES = [HeroSlide, ProblemSlide, SolutionSlide, HardwareSlide, SoftwareSlide, PortalSlide, ShowcaseSlide, IntegrationSlide, CTASlide];
export function SalesDeck() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [direction, setDirection] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);
  const paginate = useCallback((newDirection: number) => {
    const nextSlide = currentSlide + newDirection;
    if (nextSlide >= 0 && nextSlide < SLIDES.length) {
      setDirection(newDirection);
      setCurrentSlide(nextSlide);
    } else if (nextSlide >= SLIDES.length) {
      setDirection(newDirection);
      setCurrentSlide(0);
    } else if (nextSlide < 0) {
      setDirection(newDirection);
      setCurrentSlide(SLIDES.length - 1);
    }
  }, [currentSlide]);
  const handleNext = useCallback(() => {
    paginate(1);
  }, [paginate]);
  const handlePrev = useCallback(() => {
    paginate(-1);
  }, [paginate]);
  const togglePlay = useCallback(() => {
    setIsPlaying(prev => !prev);
  }, []);
  useEffect(() => {
    if (!isPlaying) return;
    const autoAdvance = setInterval(() => {
      handleNext();
    }, 8000);
    return () => clearInterval(autoAdvance);
  }, [isPlaying, handleNext]);
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'ArrowRight' || e.key === ' ') {
        e.preventDefault();
        handleNext();
      } else if (e.key === 'ArrowLeft') {
        e.preventDefault();
        handlePrev();
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [handleNext, handlePrev]);
  const SlideComponent = SLIDES[currentSlide];
  return <div className="w-full h-screen bg-[#11166b] text-white overflow-hidden relative" data-id="element-261">
      {/* Logo - Fixed position on all slides */}
      <div className="fixed top-4 left-4 md:top-8 md:left-8 z-50" data-id="element-262">
        <img src="https://cdn.magicpatterns.com/uploads/o4yRVchdb29Z7jP3r3B4LC/2025_ScoptVision_Logo-RGB_full-primary-white.png" alt="ScoptVision Logo" className="h-6 md:h-10 w-auto" data-id="element-263" />
      </div>

      <AnimatePresence initial={false} custom={direction} mode="wait" data-id="element-264">
        <motion.div key={currentSlide} custom={direction} variants={{
        enter: (direction: number) => ({
          x: direction > 0 ? 1000 : -1000,
          opacity: 0
        }),
        center: {
          zIndex: 1,
          x: 0,
          opacity: 1
        },
        exit: (direction: number) => ({
          zIndex: 0,
          x: direction < 0 ? 1000 : -1000,
          opacity: 0
        })
      }} initial="enter" animate="center" exit="exit" transition={{
        x: {
          type: 'spring',
          stiffness: 300,
          damping: 30
        },
        opacity: {
          duration: 0.2
        }
      }} className="absolute inset-0 w-full h-full" data-id="element-265">
          <SlideComponent data-id="element-266" />
        </motion.div>
      </AnimatePresence>

      <CompactNavigation onPrev={handlePrev} onNext={handleNext} isPlaying={isPlaying} onTogglePlay={togglePlay} canGoPrev={currentSlide > 0} canGoNext={currentSlide < SLIDES.length - 1} data-id="element-267" />
    </div>;
}